import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip, // <-- Import Tooltip
} from "recharts";

const BarChartNegative = ({ firstColor, secondColor, data, height }) => {
  // const CustomLabel = (props) => {
  //   const { x, y, width, value } = props;
  //   let displayValue = value;
  //   let unit = "";

  //   if (value >= 1_000_000) {
  //     displayValue = value / 1_000_000;
  //     unit = "M";
  //   } else if (value >= 1_000) {
  //     displayValue = value / 1_000;
  //     unit = "K";
  //   } else {
  //     displayValue = value;
  //     unit = "";
  //   }

  //   return (
  //     <text
  //       x={x + width + 10}
  //       y={y + 15}
  //       fill="#000"
  //       textAnchor="start"
  //       dominantBaseline="middle"
  //     >
  //       ($
  //       {displayValue.toLocaleString(undefined, {
  //         minimumFractionDigits: 2,
  //         maximumFractionDigits: 2,
  //       })}
  //       {unit})
  //     </text>
  //   );
  // };
  const CustomLabel = (props) => {
    const { x, y, width, value } = props;

    // Use absolute value for display
    const absValue = Math.abs(value);
    let displayValue = absValue;
    let unit = "";

    if (absValue >= 1_000_000) {
      displayValue = absValue / 1_000_000;
      unit = "M";
    } else if (absValue >= 1_000) {
      displayValue = absValue / 1_000;
      unit = "K";
    }

    // Format number
    const formattedValue = displayValue.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    // Add parentheses only for negative values
    const displayText =
      value < 0 ? `($${formattedValue}${unit})` : `$${formattedValue}${unit}`;

    return (
      <text
        x={x + width + 10}
        y={y + 22}
        fill="#000"
        textAnchor="start"
        dominantBaseline="middle"
      >
        {displayText}
      </text>
    );
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const value = Math.abs(payload[0].value); // ensure positive number

      return (
        <div
          style={{
            backgroundColor: "#fff",
            padding: "10px",
            border: "1px solid #ccc",
          }}
        >
          <p style={{ margin: 0 }}>{label}</p>
          <p style={{ margin: 0 }}>
            Total: ($
            {value.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
            )
          </p>
        </div>
      );
    }
    return null;
  };

  // const CustomTooltip = ({ active, payload, label }) => {
  //   if (active && payload && payload.length) {
  //     // const value = Math.abs(payload[0].value); // Use absolute value
  //     return (
  //       <div
  //         style={{
  //           backgroundColor: "#fff",
  //           padding: "10px",
  //           border: "1px solid #ccc",
  //         }}
  //       >
  //         <p style={{ margin: 0 }}>{label}</p>
  //         <p style={{ margin: 0 }}>
  //           Total:($
  //           {payload[0].value.toLocaleString(undefined, {
  //             minimumFractionDigits: 2,
  //             maximumFractionDigits: 2,
  //           })*(-1)}
  //           )
  //         </p>
  //       </div>
  //     );
  //   }
  //   return null;
  // };

  return (
    <div style={{ width: "100%", height: height, marginTop: "-40px" }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          layout="vertical"
          data={data}
          margin={{ left: 50, right: 100, top: 20, bottom: 20 }}
        >
          <defs>
            <linearGradient id="barGradient" x1="0" x2="1" y1="0" y2="0">
              <stop offset="0%" stopColor={firstColor} />
              <stop offset="100%" stopColor={secondColor} />
            </linearGradient>

            <filter id="shadow" height="130%">
              <feDropShadow
                dx="3"
                dy="3"
                stdDeviation="3"
                floodColor="rgba(0, 0, 0, 0.3)"
              />
            </filter>
          </defs>

          <YAxis
            dataKey="state"
            type="category"
            width={100}
            tick={{ fill: "#000" }}
            axisLine={false}
            tickLine={false}
          />
          <XAxis type="number" hide />

          {/* Add Tooltip */}
          <Tooltip cursor={false} content={<CustomTooltip />} />

          <Bar
            dataKey="revenue"
            fill="url(#barGradient)"
            barSize={40}
            radius={[5, 5, 5, 5]}
            label={<CustomLabel />}
            style={{ filter: "url(#shadow)" }}
            cursor={"pointer"}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BarChartNegative;
